import NivelCliente from '../../spa/nivel-cliente/NivelCliente';

export default {
  path: 'nivel-cliente',
  name: 'nivel-cliente',
  component: NivelCliente,
};
